function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgTimerOutline(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M5.292 6A8.993 8.993 0 003 11.906C2.944 16.89 7.014 20.99 12 21c4.978.009 9-4.024 9-9 0-4.9-3.917-8.888-8.79-9a.204.204 0 00-.21.204v3.92",
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M10.94 13.062L7.237 7.765a.381.381 0 01.53-.53l5.297 3.702a1.523 1.523 0 01-1.746 2.497 1.557 1.557 0 01-.378-.372z",
    fill: props.color
  }));
}

export default SvgTimerOutline;